<template>
  <div>
    <!-- <div>
      <div class="text1">申报书模板下载</div>
      <div class="flex align-items-center">
        <img class="img-box-4" src="../../assets/images/img39.png" alt="" />
        <div class="text2" style="color: #c73630; cursor: pointer">
          <a
            :href="`${path}特色文化育人品牌项目申报书.docx`"
            download="特色文化育人品牌项目申报书.docx"
            style="color: #c73630"
          >
            特色文化育人品牌项目申报书.docx</a
          >
          <span class="text2">(32.2KB)</span>
        </div>
      </div>
    </div> -->
    <!--1. 下载-->
    <div class="mb15">
      <div class="flex align-items-center mb15">
        <div class="text1">
          团队成员姓名
          <span style="color: #f6350f">*</span>
        </div>
      </div>
      <div>
        <a-input
          size="large"
          class="input-style-2"
          type="text"
          placeholder="请输入一名团队成员名称"
          v-model="info.teacher2"
          :maxLength="30"
          :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
        />
      </div>
    </div>
    <div class="mb15">
      <div class="flex align-items-center mb15">
        <div class="text1">
          联系电话
          <span style="color: #f6350f">*</span>
        </div>
      </div>
      <div>
        <a-input
          size="large"
          class="input-style-2"
          type="text"
          placeholder="请输入联系电话"
          v-model="info.phone2"
          :maxLength="11"
          onkeyup="value=value.replace(/[^\d]/g,'')"
          :disabled="$parent.editInfo && $parent.editInfo.type == 'preview'"
        />
      </div>
    </div>
    <!-- v-if="item.id == 4 || item.id == 6" -->
    <div class="mb15" v-for="(item, index) in loadList" :key="index">
      <div class="flex align-items-center mb15">
        <img class="img-box-2" :src="item.icon" alt="" />
        <div class="text1">
          {{ item.title }}
          <span style="color: #f6350f">*</span>
        </div>
      </div>
      <div>
        <a-upload
          :file-list="item.fileList"
          :accept="item.accept"
          :remove="(file, fileList) => handleRemove(file, fileList, index)"
          :customRequest="()=>{return}"
          :before-upload="
            (file, fileList) => beforeUpload(file, fileList, index, item)
          "
        >
          <a-button
            :disabled="
              ($parent.editInfo && $parent.editInfo.type == 'preview') ||
              item.loading
            "
            :loading="item.loading"
          >
            <a-icon type="upload" /> 上传附件
          </a-button>
        </a-upload>
        <div class="text2">{{ item.remarks }}</div>
      </div>
    </div>
    <div class="big-box flex">
      <div class="submit-btn btn-bg-1" @click="upStep3">上 一 步</div>
      <div class="submit-btn" @click="downStep3">下 一 步</div>
      <!-- <div class="submit-btn btn-bg-1" @click="upStep2">上 一 步</div>
      <div
        class="submit-btn btn-bg-2"
        v-if="$parent.editInfo && $parent.editInfo.type == 'preview'"
        @click="$router.push({ name: 'educationalBrand' })"
      >
        返回
      </div>
      <div v-else class="submit-btn btn-bg-2" @click="submit">提交</div> -->
    </div>
  </div>
</template>

<script>
import { fileUpdate } from '@/api/index';
export default {
  name: '',
  components: {},
  props: {
    loadList: {
      type: Array,
    },
    oldApplyFiles3: {
      type: Array,
    },
    isEnd: {
      type: String,
    },
  },
  data() {
    return {
      applyFiles: [],
      path: process.env.BASE_URL,
      loading: false,
      type4: false,
      type6: false,
      submitLoading: null,
      info: {
        teacher2: '',
        phone2: '',
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    init(params) {
      if (params) {
        this.info.teacher2 = params.teacher2;
        this.info.phone2 = params.phone2;
      }
    },
    handleRemove(file, fileList, fileindex) {
      this.applyFiles = this.applyFiles.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.loadList[fileindex].fileList.indexOf(file);
      this.$emit('deleteFile3', file);
      const newFileList = this.loadList[fileindex].fileList.slice();
      newFileList.splice(index, 1);
      this.loadList[fileindex].fileList = newFileList;
    },
    beforeUpload(file, fileList, fileindex, item) {
      this.$regFile(file, fileList, fileindex, item);
    },
    handleUpload(fileindex, file) {
      this.loadList[fileindex].loading = true;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('biz', 'linxuan');
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.filePath = res.message;
          fileItem.fileType = this.loadList[fileindex].id;
          fileItem.uid = file.uid;
          this.applyFiles.push(fileItem);
          this.$emit('upDataFile', fileItem, fileindex, 3);
          this.loadList[fileindex].loading = false;
        } else {
          this.$message.error('上传失败');
        }
      });
    },
    upStep3() {
      if (this.oldApplyFiles3 && this.oldApplyFiles3.length > 0) {
        this.applyFiles = this.applyFiles.concat(this.oldApplyFiles3);
      }
      this.$emit('upStep3', this.loadList, this.applyFiles, this.info);
    },
    downStep3() {
      if (this.info.teacher2.trim() === '' ||
        this.info.teacher2 == undefined ||
        this.info.teacher2 == null) {
          this.$message.info('请填写一位成员名字');
          return false;
      }
      if (
        (this.info && this.info.phone2 && this.info.phone2 === '') ||
        this.info.phone2 == undefined
      ) {
        this.$message.error('请输入手机号');
        return false;
      } else {
        var telStr = /^[1]([3-9])[0-9]{9}$/;
        if (!telStr.test(this.info.phone2)) {
          this.$message.error('请输入正确格式手机号');
          return false;
        }
      }
      if (this.oldApplyFiles3 && this.oldApplyFiles3.length > 0) {
        this.applyFiles = this.applyFiles.concat(this.oldApplyFiles3);
      }
      this.$emit('downStep3', this.loadList, this.applyFiles, this.info);
    },
  },
};
</script>

<style scoped lang="scss">
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin-bottom: 15px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  color: #fff;
  background: #9A0B00;
  line-height: 38px;
  text-align: center;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  cursor: pointer;
}

.big-box {
  width: 253px;
  margin: 0 auto;
}
.file-input-box {
  color: #c73630;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #c73630;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
</style>
